"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("@seedlang/utils");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _serializr = require("serializr");
var _level = _interopRequireDefault(require("./level"));
var _root_model = _interopRequireDefault(require("./root_model"));
var _sentence_simple = _interopRequireDefault(require("./sentence_simple"));
var _translation_basic = _interopRequireDefault(require("./translation_basic"));
var _translation_source_basic = _interopRequireDefault(require("./translation_source_basic"));
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var Meaning = (_dec = (0, _serializr.serializable)((0, _serializr.object)(_level["default"])), _dec2 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_translation_source_basic["default"]))), _dec3 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_sentence_simple["default"]))), _dec4 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_translation_basic["default"]))), _class = /*#__PURE__*/function (_RootModel) {
  function Meaning() {
    var _this;
    _classCallCheck(this, Meaning);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Meaning, [].concat(args));
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "position", _descriptor2, _this);
    _initializerDefineProperty(_this, "score", _descriptor3, _this);
    _initializerDefineProperty(_this, "register", _descriptor4, _this);
    _initializerDefineProperty(_this, "level", _descriptor5, _this);
    _initializerDefineProperty(_this, "translationSources", _descriptor6, _this);
    _initializerDefineProperty(_this, "sentences", _descriptor7, _this);
    _initializerDefineProperty(_this, "synonyms", _descriptor8, _this);
    return _this;
  }
  _inherits(Meaning, _RootModel);
  return _createClass(Meaning, [{
    key: "enSources",
    get: function get() {
      return this.translationSources.filter(function (ts) {
        var _ts$source;
        return ((_ts$source = ts.source) === null || _ts$source === void 0 ? void 0 : _ts$source.languageId) === 'EN';
      });
    }
  }, {
    key: "enSourcesString",
    get: function get() {
      return this.enSources.map(function (ts) {
        var _ts$source2;
        return (_ts$source2 = ts.source) === null || _ts$source2 === void 0 ? void 0 : _ts$source2.text;
      }).join(', ');
    }
  }, {
    key: "sourcesForUser",
    value: function sourcesForUser(user) {
      if (!(0, _utils.isPresent)(this.translationSources)) return [];
      var userLangId = (user === null || user === void 0 ? void 0 : user.languageId) || 'EN';
      var sources = this.translationSources.filter(function (ts) {
        var _ts$source3;
        return ((_ts$source3 = ts.source) === null || _ts$source3 === void 0 ? void 0 : _ts$source3.languageId) === userLangId;
      }).filter(function (ts) {
        return ts.accepted || !ts.userId;
      });
      if (sources.length === 0 && userLangId !== 'EN') {
        sources = this.translationSources.filter(function (ts) {
          var _ts$source4;
          return ((_ts$source4 = ts.source) === null || _ts$source4 === void 0 ? void 0 : _ts$source4.languageId) === 'EN';
        }).filter(function (ts) {
          return ts.accepted || !ts.userId;
        });
      }
      return sources.sort(function (a, b) {
        return (b.aggregateScore || 0) - (a.aggregateScore || 0);
      });
    }
  }, {
    key: "sourceTextListForUser",
    value: function sourceTextListForUser(user) {
      return this.sourcesForUser(user).map(function (ts) {
        var _ts$source5;
        return (_ts$source5 = ts.source) === null || _ts$source5 === void 0 ? void 0 : _ts$source5.text;
      }).filter(function (text) {
        return text;
      }).join(', ');
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "position", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "score", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "register", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "level", [_mobx.observable, _dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "translationSources", [_mobx.observable, _dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "sentences", [_mobx.observable, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "synonyms", [_mobx.observable, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "enSources", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "enSources"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "enSourcesString", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "enSourcesString"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sourcesForUser", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "sourcesForUser"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sourceTextListForUser", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "sourceTextListForUser"), _class.prototype), _class);
var _default = exports["default"] = Meaning;